import {
	ANALYTICS_SOURCE,
	BYLINE_ICON_COUNT_ACTION_SUBJECT,
	BYLINE_ICON_COUNT_ACTION_SUBJECT_ID,
} from '../analytics.ts';
import type { BylineIconCountAttributes } from '../utils/getBylineIconCountAttributes.ts';

/**
 * Fired once per page view after every icon source settles. The client selection precedes SSR
 * truncation and fallback padding, so its counts can differ from the rendered stack. CCINT-9528
 */
export const getBylineIconCountSettledEvent = (
	attributes: BylineIconCountAttributes,
): {
	readonly type: 'sendOperationalEvent';
	readonly data: {
		readonly action: 'settled';
		readonly actionSubject: 'bylineIconCount';
		readonly actionSubjectId: 'teamworkGraphBylineIconCount';
		readonly source: 'byline-connections';
		readonly attributes: BylineIconCountAttributes;
	};
} =>
	({
		type: 'sendOperationalEvent',
		data: {
			action: 'settled',
			actionSubject: BYLINE_ICON_COUNT_ACTION_SUBJECT,
			actionSubjectId: BYLINE_ICON_COUNT_ACTION_SUBJECT_ID,
			source: ANALYTICS_SOURCE,
			attributes,
		},
	}) as const;
